// Library Methods
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";

// Utils
import getUserFromToken from "src/utils/token/tokenHelper";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { ClinicType } from "../types";
import { getClinics } from "../api";
import { login } from "src/services/auth/api";

export const useClinicsData = () => {
  const { getToken } = useTokenAccess();
  const { isAuthenticated } = useAuth0();

  return useQuery<Array<ClinicType>>({
    queryKey: ["clinics"],
    queryFn: async () => {
      const token = await getToken();
      const { hasRole, isAdmin } = getUserFromToken(token);
      const emailData = { email: "clinic@gmail.com" };

      if (!hasRole) {
        return [];
      } else if (isAdmin) {
        return getClinics(token);
      } else {
        return login(token, emailData);
      }
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    enabled: isAuthenticated,
  });
};
